const Main = resolve => require(['@/components/main/Main.vue'], resolve)

const ProductMain = resolve => require(['@/module/quickorder/productMain.vue'], resolve)

//主页
const Home = resolve => require(['@/module/home/Home.vue'], resolve)

//消息
const Message = resolve => require(['@/module/message/messageList.vue'], resolve)

//公告管理
const NoticeList = resolve => require(['@/module/notice/noticeList.vue'], resolve)
const NoticeView = resolve => require(['@/module/notice/noticeView.vue'], resolve)

// 包材
const quickOrdersListDL = resolve => require(['@/module/quickOrders/quickOrderPacking.vue'], resolve)
const OrderConfirmPacking = resolve => require(['@/module/quickorder/confirmPacking.vue'], resolve)

//订单管理
const ShipmentList = resolve => require(['@/module/shipment/shipmentList.vue'], resolve)
const ShipmentView = resolve => require(['@/module/shipment/shipmentView.vue'], resolve)
const InvoiceList = resolve => require(['@/module/invoice/invoiceList.vue'], resolve)
const InvoiceView = resolve => require(['@/module/invoice/invoiceView.vue'], resolve)
const BillingList = resolve => require(['@/module/billing/billingList.vue'], resolve)
const BillingView = resolve => require(['@/module/billing/billingView.vue'], resolve)
const ContractList = resolve => require(['@/module/contract/ContractList.vue'], resolve)
const ContractView = resolve => require(['@/module/contract/ContractView.vue'], resolve)

//louis added on 2020/7/22 发货明细查询shipmentDetail
const ShipmentDetailList = resolve => require(['@/module/shipment/shipmentDetailList.vue'], resolve)

const SaleOrderList = resolve => require(['@/module/order/saleorderList.vue'], resolve)
const SaleOrderView = resolve => require(['@/module/order/saleorderView.vue'], resolve)

const ShoppingMallChooseProduct = resolve => require(['@/module/quickorder/chooseProduct.vue'], resolve)
const ShoppingMallChooseProductDL = resolve => require(['@/module/quickorder/chooseProductDL.vue'], resolve)
const ProductDetail = resolve => require(['@/module/quickorder/ProductDetail.vue'], resolve)
const ProductDetailDL = resolve => require(['@/module/quickorder/ProductDetailDL.vue'], resolve)
const OrderConfirm = resolve => require(['@/module/quickorder/confirm.vue'], resolve)
const OrderComplete = resolve => require(['@/module/quickorder/complete.vue'], resolve)
const ShoppingMallImportProduct = resolve => require(['@/module/quickorders/importProduct.vue'], resolve)
const ShoppingMallImportProductDL = resolve => require(['@/module/quickorder/importProductDL.vue'], resolve)
const quickShoppingMallChooseProduct = resolve => require(['@/module/quickorder/quickChooseProduct.vue'], resolve)
const quickShoppingMallChooseProductDL = resolve => require(['@/module/quickorder/quickChooseProductDL.vue'], resolve)

// 购物车页面
const ShoppingCartPage = resolve => require(['@/module/quickOrders/shoppingCart/shoppingCartPage.vue'], resolve)

// 购物车页面dl
const ShoppingCartPagedl = resolve => require(['@/module/quickorder/ShoppingCartPagedl.vue'], resolve)

const ForecastList = resolve => require(['@/module/forecast/forecastList.vue'], resolve)
const ForecastView = resolve => require(['@/module/forecast/forecastView.vue'], resolve)

const FileDownloadList = resolve => require(['@/module/filedownload/filedownloadList.vue'], resolve)
const FileDownloadView = resolve => require(['@/module/filedownload/filedownloadView.vue'], resolve)
const ForcecastReport = resolve => require(['@/module/forecast/forcecastReport.vue'], resolve)

const SalesmanList = resolve => require(['@/module/salesman/salesmanList.vue'], resolve)
const SalesmanView = resolve => require(['@/module/salesman/salesmanView.vue'], resolve)
const SalesmanEdit = resolve => require(['@/module/salesman/salesmanEdit.vue'], resolve)
//收货地址
const AccountaddressList = resolve => require(['@/module/accountaddress/accountaddressList.vue'], resolve)
//收货地址详情
const AccountaddressDetail = resolve => require(['@/module/accountaddress/accountaddressDetail.vue'], resolve)
//活动专区
const quickChoosePolicyProductList = resolve =>
  require(['@/module/quickorder/quickChoosePolicyProductList.vue'], resolve)
//更新缓存
const UpdateCache = resolve => require(['@/module/updatecache/updatecache.vue'], resolve)

const CreateOpportunity = resolve => require(['@/module/opportunity/createOpportunity.vue'], resolve)
const OpportunityList = resolve => require(['@/module/opportunity/opportunityList.vue'], resolve)
const OpportunityEdit = resolve => require(['@/module/opportunity/opportunityEdit.vue'], resolve)

//补件申请
const ResissueApplicationList = resolve =>
  require(['@/module/resissueapplication/resissueApplicationList.vue'], resolve)
const ResissueApplicationDetail = resolve =>
  require(['@/module/resissueapplication/resissueApplicationDetail.vue'], resolve)
const QuickOrderList = resolve => require(['@/module/quickorder/QuickOrderList.vue'], resolve)
const ProPriceList = resolve => require(['@/module/proprice/propriceList.vue'], resolve)
const ProPriceView = resolve => require(['@/module/proprice/propriceView.vue'], resolve)

//临时额度申请
const TempcreditList = resolve => require(['@/module/tempcredit/tempcreditList.vue'], resolve)
const TempcreditView = resolve => require(['@/module/tempcredit/tempcreditView.vue'], resolve)

//费用申请
const CostapplyList = resolve => require(['@/module/costapply/costapplyList.vue'], resolve)
const CostapplyView = resolve => require(['@/module/costapply/costapplyView.vue'], resolve)

//返利管理
const RebatedetailList = resolve => require(['@/module/rebatedetail/rebatedetailList.vue'], resolve)

//财务管理   对账单
const AccountStatementList = resolve => require(['@/module/accountstatement/accountstatementList.vue'], resolve)

const AccountStatementDetail = resolve => require(['@/module/accountstatement/accountstatementDetail.vue'], resolve)
const ResetPasswordView = resolve => require(['@/module/resetpassword/ResetPasswordView.vue'], resolve)

//快速下单功能
const quickOrdersList = resolve => require(['@/module/quickOrders/quickOrder.vue'], resolve)

//推荐产品下单
const recommendList = resolve => require(['@/module/recommend/recommendList.vue'], resolve)
const recommends = resolve => require(['@/module/recommend/recommends.vue'], resolve)
//推荐产品下单
const promotingList = resolve => require(['@/module/promoting/promotingList.vue'], resolve)
//询证函
const inquiryLetter = resolve => require(['@/module/inquiry/inquiryLetter.vue'], resolve)

const inquiryLetterDetails = resolve => require(['@/module/inquiry/inquiryLetterDetails.vue'], resolve)

//销售合同
const salesContract = resolve => require(['@/module/salesContract/salesContractList.vue'], resolve)

//销售合同明细
const salesContractView = resolve => require(['@/module/salesContract/salesContractView.vue'], resolve)

//大促\新品 DL
const promotingListDL = resolve => require(['@/module/promotingDL/promotingListDL.vue'], resolve)

//大促\新品
const promotingNew = resolve => require(['@/module/promoting/promotingNew.vue'], resolve)

// 购物流程
const shopProcessDetail = resolve => require(['@/module/footerPage/shopProcess.vue'], resolve)

//推荐产品下单 DL
const recommendListDL = resolve => require(['@/module/recommendDL/recommendListDL.vue'], resolve)

// 购物流程
const disLimit = resolve => require(['@/module/footerPage/disLimit.vue'], resolve)

// 购物流程
const insReceipt = resolve => require(['@/module/footerPage/insReceipt.vue'], resolve)

// 报表
const ordLineReport = resolve => require(['@/module/report/ordLineReport.vue'], resolve)

const ordStatistics = resolve => require(['@/module/report/ordStatistics.vue'], resolve)

const proStatistics = resolve => require(['@/module/report/proStatistics.vue'], resolve)

//秒杀产品详情
const SeckillProductInfo = resolve => require(['@/module/seckill/seckillproduct.vue'], resolve)
//秒杀清单
const seckillOrdersList = resolve => require(['@/module/seckill/seckillorderslist.vue'], resolve)

const SeckillConfirm = resolve => require(['@/module/seckill/seckillconfim.vue'], resolve)

//代发清单
const dropShippingOrderList = resolve => require(['@/module/dropshipping/dropShippingOrdersList.vue'], resolve)

//代发专区
const dropShippingProductList = resolve => require(['@/module/dropshipping/dropShippingProductList.vue'], resolve)
// 代发商品详情
const dropShippingProductDetailDL = resolve =>
  require(['@/module/dropshipping/dropShippingProductDetailDL.vue'], resolve)
// 代发商品结算
const dropShippingConfim = resolve => require(['@/module/dropshipping/dropShippingConfim.vue'], resolve)

//胶带报价
const sellotapePrice = resolve => require(['@/module/sellotape/sellotapePrice.vue'], resolve)
const MainClear = resolve => require(['@/components/main/MainClear.vue'], resolve)
// 全屏图片
const introduceImg = resolve => require(['@/components/IntroduceImg.vue'], resolve)
export default [
  {
    path: '/',
    component: Home,
    children: [
      {
        path: '/',
        name: 'home',
        meta: {
          keepAlive: true,
          allowAnonymous: true
        },
        component: Home
      }
    ]
  },
  {
    path: '/introduceImg',
    component: introduceImg,
    meta: {
      allowAnonymous: true,
      title: '介绍'
    }
  },
  {
    path: '/message',
    component: Main,
    children: [
      {
        path: 'message',
        name: 'message',
        meta: {
          keepAlive: true,
          title: '我的信息'
        },
        component: Message
      }
    ]
  },
  {
    path: '/notice',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'NoticeList',
        component: NoticeList,
        meta: {
          title: '公告通知'
        }
      },
      {
        path: 'view/:id/:readId',
        name: 'notice-detail',
        component: NoticeView
      }
    ]
  },
  {
    path: '/shoppingmall',
    component: ProductMain,
    children: [
      {
        path: 'chooseproduct/:name?/:id?',
        name: 'ShoppingMallChooseProduct',
        meta: {
          allowAnonymous: true,
          title: '商品列表'
        },
        component: ShoppingMallChooseProduct
      },
      {
        path: 'chooseproductDL/:name?/:id?',
        name: 'ShoppingMallChooseProductDL',
        meta: {
          allowAnonymous: true,
          title: '商品列表'
        },
        component: ShoppingMallChooseProductDL
      },
      {
        path: 'productdetail',
        name: 'product-detail',
        meta: {
          allowAnonymous: true,
          title: '商品详情'
        },
        component: ProductDetail
      },
      {
        path: 'productdetailDL',
        name: 'product-detail-dl',
        meta: {
          allowAnonymous: true,
          title: '商品详情'
        },
        component: ProductDetailDL
      },
      // 页面推荐产品 列表入口
      {
        path: 'quickChooseproduct/:entryname/:mainid',
        name: 'quickShoppingMallChooseProduct',
        meta: {
          allowAnonymous: true
        },
        component: quickShoppingMallChooseProduct
      },
      // 页面推荐产品DL 列表入口
      {
        path: 'quickChooseproductDL/:entryname/:mainid/:tabName?',
        name: 'quickShoppingMallChooseProductDL',
        meta: {
          allowAnonymous: true
        },
        component: quickShoppingMallChooseProductDL
      },
      //活动专区
      {
        path: 'quickChoosePolicyProduct',
        name: 'quickChoosePolicyProductList',
        component: quickChoosePolicyProductList,
        meta: {
          title: '政策专区'
        }
      },
      //代发专区
      {
        path: 'dropShippingProduct',
        name: 'dropShippingProductList',
        component: dropShippingProductList,
        meta: {
          title: '代发专区'
        }
      },
      //代发商品详情
      {
        path: 'dropShippingProductDetailDL',
        name: 'dropShippingProductDetailDL',
        component: dropShippingProductDetailDL,
        meta: {
          allowAnonymous: true,
          title: '商品详情'
        }
      },
      {
        path: 'productForPartner',
        name: 'productForPartner',
        component: () => import('@/module/quickorder/productForPartner.vue'),
        meta: {
          allowAnonymous: true,
          title: '伙伴专区'
        }
      },
    ]
  },
  {
    path: '/dropshippingconfirm/:id',
    name: 'dropshippingconfirm',
    component: dropShippingConfim,
    meta: {
      title: '代发产品结算'
    }
  },
  {
    path: '/shipment',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'ShipmentList',
        component: ShipmentList,
        meta: {
          title: '发货查询'
        }
      },
      {
        path: 'view/:id',
        name: 'ShipmentView',
        component: ShipmentView
      }
    ]
  },
  {
    /*louis added on 2020/7/22 发货明细查询 */
    path: '/shipmentDetail',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'ShipmentDetailList',
        component: ShipmentDetailList,
        meta: {
          title: '发货查询'
        }
      }
    ]
  },
  {
    path: '/invoice',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'InvoiceList',
        component: InvoiceList
      },
      {
        path: 'view/:id',
        name: 'InvoiceView',
        component: InvoiceView
      }
    ]
  },
  {
    path: '/billing',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'BillingList',
        component: BillingList
      },
      {
        path: 'view/:id',
        name: 'BillingView',
        component: BillingView
      }
    ]
  },
  {
    path: '/order',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'SaleOrderList',
        component: SaleOrderList,
        meta: {
          title: '我的订单'
        }
      },
      {
        path: ':id/complete',
        name: 'OrderComplete',
        component: OrderComplete
      },
      {
        path: ':id/detail',
        name: 'order-detail',
        component: SaleOrderView,
        meta: {
          title: '订单详情'
        }
      }
    ]
  },
  {
    name: 'ShoppingCartPage',
    component: ShoppingCartPage,
    path: '/shoppingCartPage',
    meta: {
      title: '购物车'
    }
  },
  //购物车 dl
  {
    name: 'ShoppingCartPagedl',
    component: ShoppingCartPagedl,
    path: '/shoppingCartPagedl',
    meta: {
      title: '购物车'
    }
  },
  {
    name: 'OrderConfirm',
    component: OrderConfirm,
    path: '/confirm/:id/order',
    meta: {
      title: '订单结算'
    }
  },
  {
    name: 'OrderConfirmPacking',
    component: OrderConfirmPacking,
    path: '/confirmPacking/:id/order',
    meta: {
      title: '包材订单结算'
    }
  },
  {
    path: '/quickorder',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'QuickOrderList',
        component: QuickOrderList,
        meta: {
          title: '快速导入'
        }
      },
      {
        path: 'importproduct',
        name: 'importproduct',
        meta: {
          keepAlive: true,
          allowAnonymous: true,
          title: '快速导入'
        },
        component: ShoppingMallImportProduct
      },
      {
        path: 'importproductDL',
        name: 'importproductDL',
        meta: {
          keepAlive: true,
          allowAnonymous: true,
          title: '快速导入'
        },
        component: ShoppingMallImportProductDL
      }
    ]
  },
  {
    path: '/contract',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'ContractList',
        component: ContractList
      },
      {
        path: 'view/:id',
        name: 'ContractView',
        component: ContractView
      }
    ]
  },
  {
    path: '/proprice',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'ProPriceList',
        component: ProPriceList
      },
      {
        path: 'create',
        name: 'ProPriceCreate',
        component: ProPriceView
      },
      {
        path: 'view/:id',
        name: 'proprice-detail',
        component: ProPriceView
      }
    ]
  },
  {
    path: '/salesforecast',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'ForecastList',
        component: ForecastList
      },
      {
        path: 'view/:id',
        name: 'ForecastView',
        component: ForecastView
      },
      {
        path: 'create',
        name: 'ForecastCreate',
        component: ForecastView
      },
      {
        path: 'report',
        name: 'ForcecastReport',
        component: ForcecastReport
      }
    ]
  },
  {
    path: '/filedownload',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'FileDownloadList',
        component: FileDownloadList,
        meta: {
          title: '资料下载'
        }
      },
      {
        path: 'view/:id',
        name: 'FileDownloadView',
        component: FileDownloadView
      }
    ]
  },
  {
    path: '/salesman',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'SalesmanList',
        component: SalesmanList,
        meta: {
          title: '人员档案'
        }
      },
      {
        path: 'Edit/:id',
        name: 'SalesmanEdit',
        component: SalesmanEdit
      },
      {
        path: 'view',
        name: 'SalesmanView',
        component: SalesmanView
      }
    ]
  },
  {
    path: '/updatecache',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'UpdateCache',
        component: UpdateCache
      }
    ]
  },
  {
    path: '/accountaddress',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'AccountaddressList',
        component: AccountaddressList,
        meta: {
          title: '收货地址'
        }
      },
      {
        path: 'Detail/:id',
        name: 'AccountaddressDetail',
        component: AccountaddressDetail,
        meta: {
          title: '收货地址'
        }
      }
    ]
  },
  {
    path: '/opportunity',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'OpportunityList',
        component: OpportunityList
      },
      {
        path: 'edit/:id',
        name: 'OpportunityEdit',
        component: OpportunityEdit
      },
      {
        path: 'create',
        name: 'CreateOpportunity',
        component: CreateOpportunity
      }
    ]
  },
  {
    path: '/resissueapplication',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'ResissueApplicationList',
        component: ResissueApplicationList
      },
      {
        path: 'detail/:id',
        name: 'ResissueApplicationDetail',
        component: ResissueApplicationDetail
      }
    ]
  },
  {
    path: '/tempcredit',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'TempcreditList',
        component: TempcreditList
      },
      {
        path: 'view/:id',
        name: 'tempcredit-detail',
        component: TempcreditView
      },
      {
        path: 'create',
        name: 'TempcreditCreate',
        component: TempcreditView
      }
    ]
  },
  {
    path: '/costapply',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'CostapplyList',
        component: CostapplyList
      },
      {
        path: 'view/:id',
        name: 'costapply-detail',
        component: CostapplyView
      },
      {
        path: 'create',
        name: 'CostapplyCreate',
        component: CostapplyView
      }
    ]
  },
  {
    path: '/rebatedetail',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'RebatedetailList',
        component: RebatedetailList
      }
    ]
  },
  {
    path: '/accountstatementlist',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'accountstatementList',
        component: AccountStatementList,
        meta: {
          title: '往来对账'
        }
      }
    ]
  },
  {
    path: '/accountstatementDetail/:id',
    component: Main,
    children: [
      {
        path: 'detail',
        name: 'accountstatement-detail',
        component: AccountStatementDetail
      }
    ]
  },
  {
    path: '/resetpassword',
    component: Main,
    children: [
      {
        path: 'view',
        name: 'resetpassword-view',
        component: ResetPasswordView
      }
    ]
  },
  {
    path: '/quickOrders',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'quickOrdersList',
        component: quickOrdersList,
        meta: {
          title: '快速下单'
        }
      }
    ]
  },
  {
    path: '/quickOrdersDL',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'quickOrdersListDL',
        component: quickOrdersListDL,
        meta: {
          title: '包材下单',
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '/recommend',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'recommendList',
        component: recommendList,
        meta: {
          title: '推荐产品下单'
        }
      }
    ]
  },
  {
    path: '/recommends',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'recommends',
        component: recommends,
        meta: {
          title: '推荐产品下单'
        }
      }
    ]
  },
  {
    path: '/Promoting',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'promotingList',
        component: promotingList,
        meta: {
          title: '大促/新品下单'
        }
      }
    ]
  },
  {
    path: '/Inquiry',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'inquiryLetter',
        component: inquiryLetter,
        meta: {
          title: '询证函'
        }
      }
    ]
  },
  {
    path: '/Inquirys',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'inquiryLetterDetails',
        component: inquiryLetterDetails
      }
    ]
  },
  {
    path: '/salesContract',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'salesContract',
        component: salesContract
      },
      {
        path: 'view/:id',
        name: 'salesContractView',
        component: salesContractView
      }
    ]
  },
  {
    path: '/salesContractView',
    component: Main,
    children: [
      {
        path: 'view',
        name: 'salesContractView',
        component: salesContractView
      }
    ]
  },
  {
    path: '/promotingDL',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'promotingListDL',
        component: promotingListDL,
        meta: {
          title: '大促/新品下单'
        }
      }
    ]
  },
  {
    path: '/promotingNew',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'promotingNew',
        component: promotingNew,
        meta: {
          title: '大促/新品下单'
        }
      }
    ]
  },
  {
    path: '/recommendListDL',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'recommendListDL',
        component: recommendListDL,
        meta: {
          title: '推荐产品下单'
        }
      }
    ]
  },

  {
    path: '/shopProcess',
    component: Main,
    children: [
      {
        path: 'detail',
        name: 'shopProcessDetail',
        component: shopProcessDetail,
        meta: {
          title: '购物流程'
        }
      }
    ]
  },
  {
    path: '/disLimit',
    component: Main,
    children: [
      {
        path: 'detail',
        name: 'disLimit',
        component: disLimit,
        meta: {
          title: '配送服务与时效说明'
        }
      }
    ]
  },
  {
    path: '/insReceipt',
    component: Main,
    children: [
      {
        path: 'detail',
        name: 'insReceipt',
        component: insReceipt,
        meta: {
          title: '配送服务与时效说明'
        }
      }
    ]
  },
  {
    path: '/report',
    component: Main,
    children: [
      {
        path: 'ordLine',
        component: ordLineReport,
        meta: {
          title: '订单明细统计'
        }
      }
    ]
  },
  {
    path: '/report',
    component: Main,
    children: [
      {
        path: 'ordStatistics',
        component: ordStatistics,
        meta: {
          title: '订单统计'
        }
      }
    ]
  },
  {
    path: '/report',
    component: Main,
    children: [
      {
        path: 'proStatistics',
        component: proStatistics,
        meta: {
          title: '商品统计'
        }
      }
    ]
  },
  {
    path: '/seckillhome',
    name: 'seckillhome',
    component: () => import('./seckill/seckillhome.vue'),
    meta: {
      title: '秒杀'
    }
  },
  {
    path: '/seckillProductInfo',
    name: 'seckillproduct-detail',
    meta: {
      allowAnonymous: true,
      title: '商品详情'
    },
    component: SeckillProductInfo
  },
  {
    path: '/seckillconfirm/:id',
    name: 'seckillconfirm',
    component: SeckillConfirm,
    meta: {
      title: '秒杀产品结算'
    }
  },
  {
    path: '/seckillorderlist',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'seckillorderlist',
        component: seckillOrdersList,
        meta: {
          title: '秒杀清单'
        }
      }
    ]
  },
  {
    path: '/dropshippingorderlist',
    component: Main,
    children: [
      {
        path: 'list',
        name: 'dropshippingorderlist',
        component: dropShippingOrderList,
        meta: {
          title: '代发清单'
        }
      }
    ]
  },
  {
    path: '/sellotape',
    component: MainClear,
    children: [
      {
        path: 'list',
        name: 'sellotape',
        component: sellotapePrice,
        meta: {
          title: '胶带定制'
        }
      }
    ]
  },
  {
    path: '/antiFraud',
    name: 'AntiFraud',
    component: () => import('./antiFraud/antiFraud.vue'),
    meta: {
      title: '舞弊举报'
    }
  },
  {
    path: '/customerService',
    name: 'customerService',
    component: () => import('@/components/iframe/customerService'),
    meta: {
      title: '客服热线'
    }
  },
  {
    path: '/logisticsProgress',
    name: 'LogisticsProgress',
    component: () => import('@/components/logisticsProgress'),
    meta: {
      title: '出货进度'
    }
  }
]



// WEBPACK FOOTER //
// ./src/module/router.js